import { Component, OnInit } from '@angular/core';
import { CommonFunctionService} from "./../../../services/Common/common-function.service";
import { Router } from '@angular/router';
import { EmployeeService } from '../../../POS/POSServices/Employees/employee.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-pos-header',
  templateUrl: './pos-header.component.html',
  styleUrls: ['./pos-header.component.scss']
})
export class PosHeaderComponent implements OnInit {
  rows=[];
  MerchantKeyId:any;
  resellerno:any;
  posvalue=0;
  username: any;
  isShown:boolean=false;
  navCollapsed = true; // for horizontal layout
  menuItems = []; // for horizontal layout
  submenu = true; // for horizontal layout
  submenupos = true;
  reportmenu = true;
  settingsmenu = true;
  profilemenu = true;
 
  constructor(private commonfunction: CommonFunctionService,private router: Router, private service: EmployeeService) { 
    this.username = this.commonfunction.getUserName();
    this.Posoption();
  }
  get headerTitle () {
    if (this.router.url.includes('/pos/customer/manage')) {
     return 'Manage Customer';
   } 
   else if (this.router.url.includes('/pos/employee/manage')) {
     return 'Manage Employee';
   } 
   else if (this.router.url.includes('/pos/orders/manage')){
     return 'Manage Orders';
   }
   else if (this.router.url.includes('/pos/businesshour/manage')) {
     return 'Manage Business hours';
   }
   else if (this.router.url.includes('/pos/item/manage')) {
     return 'Manage Items';
   }
   else if (this.router.url.includes('/pos/category/manage')) {
     return 'Manage Item Category';
   }
   
   else if (this.router.url.includes('/pos/ordertype/manage')) {
     return 'Manage Order Type';
   }
   else if (this.router.url.includes('/pos/payment/manage')) {
     return 'Manage Payment';
   }
   else if (this.router.url.includes('/pos/taxfee/manage')) {
     return 'Manage Tax Fee';
   }
   else if (this.router.url.includes('/pos/tips/manage')) {
     return 'Manage Tips  ';
   }
   else if (this.router.url.includes('/pos/businessinfo')) {
     return 'Business Info';
   }
    else if (this.router.url.includes('/pos/customer/new')) {
     return 'New Customer';
   }
   else if (this.router.url.includes('/pos/Employee/new')) {
    return 'New Employee';
  }
  
  else if (this.router.url.includes('/pos/orders/new')) {
    return 'New Order';
  }
  else if (this.router.url.includes('/pos/voucher/add')) {
    return 'New Voucher';
  }
 
  else if (this.router.url.includes('/pos/businesshour/new')) {
    return 'New Business Hours';
  }
  else if (this.router.url.includes('/pos/item/new')) {
    return 'New Item';
  }
  else if (this.router.url.includes('/pos/supplier/add')) {
    return 'Add Supplier';
  }
  else if (this.router.url.includes('/pos/category/new')) {
    return 'New Item Category';
  }
  else if (this.router.url.includes('/pos/order/new')) {
    return 'New Order';
  }
  else if (this.router.url.includes('/pos/orderreceipt/new')) {
    return 'New Order Receipt';
  }
   else if (this.router.url.includes('/pos/payment/new')) {
    return 'New Payment';
  }
  else if (this.router.url.includes('/pos/paymentrecipt/new')) {
    return 'New Payment Receipt';
  }
  else if (this.router.url.includes('/pos/taxfee/new')) {
    return 'New Tax Fee';
  }
  else if (this.router.url.includes('/pos/tip/new')) {
    return 'New Tips';
  }
  else if (this.router.url.includes('/pos/customer/view')) {
    return 'View Customer';
  }
  else if (this.router.url.includes('/pos/Employee/view')) {
   return 'View Employee';
 }
 
 else if (this.router.url.includes('/pos/orderdetails/view')) {
   return 'View Order';
 }
 
 else if (this.router.url.includes('/pos/businesshour/view')) {
   return 'View Business Hours';
 }
 else if (this.router.url.includes('/pos/item/view')) {
   return 'View Item';
 }
 else if (this.router.url.includes('/pos/category/view')) {
   return 'View Category';
 }
 else if (this.router.url.includes('/pos/ordertype/view')) {
   return 'View Order';
 }
  else if (this.router.url.includes('/pos/payment/view')) {
   return 'View Payment';
 }
 else if (this.router.url.includes('/pos/paymentrecipt/new')) {
   return 'New Payment Receipt';
 }
 else if (this.router.url.includes('/pos/taxfee/view')) {
   return 'View Taxfee';
 }
 else if (this.router.url.includes('//pos/tips/view')) {
   return 'View Tips';
 }

 else if (this.router.url.includes('/transactiondetails;id=')){
  return 'Transaction view page'
}
  
   
  
   
   
   else {
     return 'Dashboard';
   }
 }
  ngOnInit() {
  }



  
  Posoption()
{
  this.MerchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
  this.resellerno =this.commonfunction.getUserMerchantData().ResellerId;
this.service.getMerchantServicesAndFees(this.MerchantKeyId,this.resellerno).subscribe(result => {
    if(result !=null)
    {

      this.rows = _clone(result);;
      
      this.rows.forEach(element => {
        if (element.ServiceCode == "Pos" && element.Status==1)
         {
                this.posvalue=1;
         }
      });
      if(this.posvalue==1)
      {
      }
      else{
        this.router.navigate(["/home"]);
      }
    
    }

   

  });
 
}
}
